module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/pui-react-lists/~/babel-runtime/core-js/object/define-property.js
// module id = 3214
// module chunks = 0